"use strict";

var _defineProperty = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeUnchecked = exports.deserialize = exports.serialize = exports.BinaryReader = exports.BinaryWriter = exports.BorshError = exports.baseDecode = exports.baseEncode = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var bs58_1 = __importDefault(require("bs58")); // TODO: Make sure this polyfill not included when not required


var encoding = __importStar(require("text-encoding-utf-8"));

var TextDecoder = typeof global.TextDecoder !== 'function' ? encoding.TextDecoder : global.TextDecoder;
var textDecoder = new TextDecoder('utf-8', {
  fatal: true
});

function baseEncode(value) {
  if (typeof value === 'string') {
    value = Buffer.from(value, 'utf8');
  }

  return bs58_1.default.encode(Buffer.from(value));
}

exports.baseEncode = baseEncode;

function baseDecode(value) {
  return Buffer.from(bs58_1.default.decode(value));
}

exports.baseDecode = baseDecode;
var INITIAL_LENGTH = 1024;

var BorshError = /*#__PURE__*/function (_Error) {
  _inherits(BorshError, _Error);

  var _super = _createSuper(BorshError);

  function BorshError(message) {
    var _this;

    _classCallCheck(this, BorshError);

    _this = _super.call(this, message);
    _this.fieldPath = [];
    _this.originalMessage = message;
    return _this;
  }

  _createClass(BorshError, [{
    key: "addToFieldPath",
    value: function addToFieldPath(fieldName) {
      this.fieldPath.splice(0, 0, fieldName); // NOTE: Modifying message directly as jest doesn't use .toString()

      this.message = this.originalMessage + ': ' + this.fieldPath.join('.');
    }
  }]);

  return BorshError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.BorshError = BorshError; /// Binary encoder.

var BinaryWriter = /*#__PURE__*/function () {
  function BinaryWriter() {
    _classCallCheck(this, BinaryWriter);

    this.buf = Buffer.alloc(INITIAL_LENGTH);
    this.length = 0;
  }

  _createClass(BinaryWriter, [{
    key: "maybeResize",
    value: function maybeResize() {
      if (this.buf.length < 16 + this.length) {
        this.buf = Buffer.concat([this.buf, Buffer.alloc(INITIAL_LENGTH)]);
      }
    }
  }, {
    key: "writeU8",
    value: function writeU8(value) {
      this.maybeResize();
      this.buf.writeUInt8(value, this.length);
      this.length += 1;
    }
  }, {
    key: "writeU16",
    value: function writeU16(value) {
      this.maybeResize();
      this.buf.writeUInt16LE(value, this.length);
      this.length += 2;
    }
  }, {
    key: "writeU32",
    value: function writeU32(value) {
      this.maybeResize();
      this.buf.writeUInt32LE(value, this.length);
      this.length += 4;
    }
  }, {
    key: "writeU64",
    value: function writeU64(value) {
      this.maybeResize();
      this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray('le', 8)));
    }
  }, {
    key: "writeU128",
    value: function writeU128(value) {
      this.maybeResize();
      this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray('le', 16)));
    }
  }, {
    key: "writeU256",
    value: function writeU256(value) {
      this.maybeResize();
      this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray('le', 32)));
    }
  }, {
    key: "writeU512",
    value: function writeU512(value) {
      this.maybeResize();
      this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray('le', 64)));
    }
  }, {
    key: "writeBuffer",
    value: function writeBuffer(buffer) {
      // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
      this.buf = Buffer.concat([Buffer.from(this.buf.subarray(0, this.length)), buffer, Buffer.alloc(INITIAL_LENGTH)]);
      this.length += buffer.length;
    }
  }, {
    key: "writeString",
    value: function writeString(str) {
      this.maybeResize();
      var b = Buffer.from(str, 'utf8');
      this.writeU32(b.length);
      this.writeBuffer(b);
    }
  }, {
    key: "writeFixedArray",
    value: function writeFixedArray(array) {
      this.writeBuffer(Buffer.from(array));
    }
  }, {
    key: "writeArray",
    value: function writeArray(array, fn) {
      this.maybeResize();
      this.writeU32(array.length);

      var _iterator = _createForOfIteratorHelper(array),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var elem = _step.value;
          this.maybeResize();
          fn(elem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.buf.subarray(0, this.length);
    }
  }]);

  return BinaryWriter;
}();

exports.BinaryWriter = BinaryWriter;

function handlingRangeError(target, propertyKey, propertyDescriptor) {
  var originalMethod = propertyDescriptor.value;

  propertyDescriptor.value = function () {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return originalMethod.apply(this, args);
    } catch (e) {
      if (e instanceof RangeError) {
        var code = e.code;

        if (['ERR_BUFFER_OUT_OF_BOUNDS', 'ERR_OUT_OF_RANGE'].indexOf(code) >= 0) {
          throw new BorshError('Reached the end of buffer when deserializing');
        }
      }

      throw e;
    }
  };
}

var BinaryReader = /*#__PURE__*/function () {
  function BinaryReader(buf) {
    _classCallCheck(this, BinaryReader);

    this.buf = buf;
    this.offset = 0;
  }

  _createClass(BinaryReader, [{
    key: "readU8",
    value: function readU8() {
      var value = this.buf.readUInt8(this.offset);
      this.offset += 1;
      return value;
    }
  }, {
    key: "readU16",
    value: function readU16() {
      var value = this.buf.readUInt16LE(this.offset);
      this.offset += 2;
      return value;
    }
  }, {
    key: "readU32",
    value: function readU32() {
      var value = this.buf.readUInt32LE(this.offset);
      this.offset += 4;
      return value;
    }
  }, {
    key: "readU64",
    value: function readU64() {
      var buf = this.readBuffer(8);
      return new bn_js_1.default(buf, 'le');
    }
  }, {
    key: "readU128",
    value: function readU128() {
      var buf = this.readBuffer(16);
      return new bn_js_1.default(buf, 'le');
    }
  }, {
    key: "readU256",
    value: function readU256() {
      var buf = this.readBuffer(32);
      return new bn_js_1.default(buf, 'le');
    }
  }, {
    key: "readU512",
    value: function readU512() {
      var buf = this.readBuffer(64);
      return new bn_js_1.default(buf, 'le');
    }
  }, {
    key: "readBuffer",
    value: function readBuffer(len) {
      if (this.offset + len > this.buf.length) {
        throw new BorshError("Expected buffer length ".concat(len, " isn't within bounds"));
      }

      var result = this.buf.slice(this.offset, this.offset + len);
      this.offset += len;
      return result;
    }
  }, {
    key: "readString",
    value: function readString() {
      var len = this.readU32();
      var buf = this.readBuffer(len);

      try {
        // NOTE: Using TextDecoder to fail on invalid UTF-8
        return textDecoder.decode(buf);
      } catch (e) {
        throw new BorshError("Error decoding UTF-8 string: ".concat(e));
      }
    }
  }, {
    key: "readFixedArray",
    value: function readFixedArray(len) {
      return new Uint8Array(this.readBuffer(len));
    }
  }, {
    key: "readArray",
    value: function readArray(fn) {
      var len = this.readU32();
      var result = Array();

      for (var i = 0; i < len; ++i) {
        result.push(fn());
      }

      return result;
    }
  }]);

  return BinaryReader;
}();

__decorate([handlingRangeError], BinaryReader.prototype, "readU8", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU16", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU32", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU64", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU128", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU256", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readU512", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readString", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readFixedArray", null);

__decorate([handlingRangeError], BinaryReader.prototype, "readArray", null);

exports.BinaryReader = BinaryReader;

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function serializeField(schema, fieldName, value, fieldType, writer) {
  try {
    // TODO: Handle missing values properly (make sure they never result in just skipped write)
    if (typeof fieldType === 'string') {
      writer["write".concat(capitalizeFirstLetter(fieldType))](value);
    } else if (fieldType instanceof Array) {
      if (typeof fieldType[0] === 'number') {
        if (value.length !== fieldType[0]) {
          throw new BorshError("Expecting byte array of length ".concat(fieldType[0], ", but got ").concat(value.length, " bytes"));
        }

        writer.writeFixedArray(value);
      } else {
        writer.writeArray(value, function (item) {
          serializeField(schema, fieldName, item, fieldType[0], writer);
        });
      }
    } else if (fieldType.kind !== undefined) {
      switch (fieldType.kind) {
        case 'option':
          {
            if (value === null || value === undefined) {
              writer.writeU8(0);
            } else {
              writer.writeU8(1);
              serializeField(schema, fieldName, value, fieldType.type, writer);
            }

            break;
          }

        default:
          throw new BorshError("FieldType ".concat(fieldType, " unrecognized"));
      }
    } else {
      serializeStruct(schema, value, writer);
    }
  } catch (error) {
    if (error instanceof BorshError) {
      error.addToFieldPath(fieldName);
    }

    throw error;
  }
}

function serializeStruct(schema, obj, writer) {
  var structSchema = schema.get(obj.constructor);

  if (!structSchema) {
    throw new BorshError("Class ".concat(obj.constructor.name, " is missing in schema"));
  }

  if (structSchema.kind === 'struct') {
    structSchema.fields.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          fieldName = _ref2[0],
          fieldType = _ref2[1];

      serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
  } else if (structSchema.kind === 'enum') {
    var name = obj[structSchema.field];

    for (var idx = 0; idx < structSchema.values.length; ++idx) {
      var _structSchema$values$ = _slicedToArray(structSchema.values[idx], 2),
          fieldName = _structSchema$values$[0],
          fieldType = _structSchema$values$[1];

      if (fieldName === name) {
        writer.writeU8(idx);
        serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
        break;
      }
    }
  } else {
    throw new BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(obj.constructor.name));
  }
} /// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }


function serialize(schema, obj) {
  var writer = new BinaryWriter();
  serializeStruct(schema, obj, writer);
  return writer.toArray();
}

exports.serialize = serialize;

function deserializeField(schema, fieldName, fieldType, reader) {
  try {
    if (typeof fieldType === 'string') {
      return reader["read".concat(capitalizeFirstLetter(fieldType))]();
    }

    if (fieldType instanceof Array) {
      if (typeof fieldType[0] === 'number') {
        return reader.readFixedArray(fieldType[0]);
      }

      return reader.readArray(function () {
        return deserializeField(schema, fieldName, fieldType[0], reader);
      });
    }

    if (fieldType.kind === 'option') {
      var option = reader.readU8();

      if (option) {
        return deserializeField(schema, fieldName, fieldType.type, reader);
      }

      return undefined;
    }

    return deserializeStruct(schema, fieldType, reader);
  } catch (error) {
    if (error instanceof BorshError) {
      error.addToFieldPath(fieldName);
    }

    throw error;
  }
}

function deserializeStruct(schema, classType, reader) {
  var structSchema = schema.get(classType);

  if (!structSchema) {
    throw new BorshError("Class ".concat(classType.name, " is missing in schema"));
  }

  if (structSchema.kind === 'struct') {
    var result = {};

    var _iterator2 = _createForOfIteratorHelper(schema.get(classType).fields),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            fieldName = _step2$value[0],
            fieldType = _step2$value[1];

        result[fieldName] = deserializeField(schema, fieldName, fieldType, reader);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return new classType(result);
  }

  if (structSchema.kind === 'enum') {
    var idx = reader.readU8();

    if (idx >= structSchema.values.length) {
      throw new BorshError("Enum index: ".concat(idx, " is out of range"));
    }

    var _structSchema$values$2 = _slicedToArray(structSchema.values[idx], 2),
        _fieldName = _structSchema$values$2[0],
        _fieldType = _structSchema$values$2[1];

    var fieldValue = deserializeField(schema, _fieldName, _fieldType, reader);
    return new classType(_defineProperty({}, _fieldName, fieldValue));
  }

  throw new BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(classType.constructor.name));
} /// Deserializes object from bytes using schema.


function deserialize(schema, classType, buffer) {
  var reader = new BinaryReader(buffer);
  var result = deserializeStruct(schema, classType, reader);

  if (reader.offset < buffer.length) {
    throw new BorshError("Unexpected ".concat(buffer.length - reader.offset, " bytes after deserialized data"));
  }

  return result;
}

exports.deserialize = deserialize; /// Deserializes object from bytes using schema, without checking the length read

function deserializeUnchecked(schema, classType, buffer) {
  var reader = new BinaryReader(buffer);
  return deserializeStruct(schema, classType, reader);
}

exports.deserializeUnchecked = deserializeUnchecked;